import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Component that redirects users to appropriate dashboard based on their role
 */
const RoleBasedRedirect = ({ fallback = '/login' }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(fallback);
      } else {
        switch (user.role) {
          case 'superadmin':
            navigate('/superadmin/dashboard');
            break;
          case 'admin':
            navigate('/admin/dashboard');
            break;
          case 'staff':
            navigate('/staff/dashboard');
            break;
          case 'member':
            navigate('/member/dashboard');
            break;
          default:
            navigate('/member/dashboard');
            break;
        }
      }
    }
  }, [user, loading, navigate, fallback]);

  return null; // This component doesn't render anything
};

export default RoleBasedRedirect;
